import React from 'react'
import "./hero.css"
import { Link } from "react-router-dom/cjs/react-router-dom"

const Messages = () => {
  return (
    <>
      <div className='w-full flex h-screen items-start heromessages'>
        <div className='relative w-full md:w-1/2 h-full flex flex-col mx-4 md:mx-12'>
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center p-6 md:p-12 bg-black/60 rounded-2xl shadow-xl max-w-xl w-full modern-card'>
            <h1 className='text-3xl md:text-5xl font-extrabold text-white text-center tracking-tight mb-4 drop-shadow-lg'>
              SMS PLATFORM
            </h1>
            <p className='text-base md:text-lg text-gray-100 font-medium text-center mb-8 leading-relaxed'>
              FRT upscaled the SMS platform for dissemination of advisories and relevant information to farmers. Over <span className="font-bold text-yellow-300">900,000 farmers</span> received advisories and information this year. The system also provided real-time delivery status updates, allowing administrators to monitor the progress of the push campaign and address any potential issues promptly.
              <br /><br />
              The SMS platform supported farmers with messages on various value chains.
            </p>
            <div className="flex gap-4 flex-wrap justify-center">
              <Link to="/services">
                <button className='inline-flex items-center px-6 py-3 bg-gradient-to-r from-yellow-400 to-green-400 text-white font-semibold rounded-full shadow-md hover:from-yellow-500 hover:to-green-500 transition text-base md:text-lg modern-btn'>
                  <i className="fa fa-phone mr-2"></i>
                  Call Us Now
                </button>
              </Link>
              <Link to="/services">
                <button className='inline-flex items-center px-6 py-3 bg-white text-gray-900 font-semibold rounded-full shadow-md hover:bg-gray-100 transition text-base md:text-lg border border-gray-200 modern-btn' style={{background: "#fff", color: "#222"}}>
                  <i className='fa fa-envelope-open mr-2'></i>
                  Read More
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className='relative hidden md:block w-0 md:w-1/2 h-full '>
          {/* You can add an image or illustration here if needed */}
        </div>
      </div>
    </>
  )
}

export default Messages
